// CSV export shared by every report in the app.
//
// Rows in, file out. Callers pass plain arrays of arrays (first row = header)
// so each report decides its own shape and column order — this file only
// knows how to serialise and hand the browser a download.

// Excel and Sheets treat a leading =, +, -, or @ as the start of a formula,
// so a value like "-500" or an imported "=cmd|..." string can execute or
// display wrong when the exported file is reopened. Prefixing with a single
// quote forces the cell to be read as text.
function neutralizeFormula(value) {
  return /^[=+\-@\t\r]/.test(value) ? `'${value}` : value;
}

function escapeCell(value) {
  if (value === null || value === undefined) return '""';
  const raw = String(value);
  const safe = neutralizeFormula(raw);
  // Always quote and double any internal quotes: cheaper than deciding
  // per-cell whether a comma/newline/quote is present, and always valid.
  return `"${safe.replace(/"/g, '""')}"`;
}

export function toCsv(rows) {
  return rows.map((row) => row.map(escapeCell).join(',')).join('\r\n');
}

export function downloadCsv(filename, rows) {
  // The BOM is what makes Excel read the file as UTF-8; without it, the
  // J$ prefix and any accented vendor names come out mangled.
  const blob = new Blob(['﻿', toCsv(rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
